<div soho-busyindicator style="flex-direction: column"
  [text]="'BuildingReportList' | translate"
  [displayDelay]="20"
  [timeToComplete]="busyTimeOut">
  <div class="form-layout-compact">
    @if (true) {
      <div class="lm-flex-field-set-header">
        <div data-automation-id="lm-report-security-items-title" class="fieldset-title">{{'Reports' | translate }}
          <lm-mouse-over-text data-automation-id="lm-report-security-items-info" [mouseOverTextContents]="'DeliveredReportHelp' | translate"></lm-mouse-over-text></div>
        </div>
        <div id="lm-report-sec-list">
          @if (displayDataGrid) {
            <lm-reports-security-list
              [reportsArray]="reportsArray"
              uniqueId="reportSecurity"
              (notAccessibleClicked)="onNotAccessibleClicked($event)"
            ></lm-reports-security-list>
          }
        </div>
      }
      @if (true) {
        <div class="lm-flex-column-responsive-container">
          <div class="lm-flex-field-set-header">
            <div data-automation-id="lm-report-security-inaccessible-items-title" class="fieldset-title">{{'InaccessibleItems' | translate }}
              <lm-mouse-over-text data-automation-id="lm-report-security-inaccessible-items-info" [mouseOverTextContents]="'InaccessibleReportItemsHelp' | translate"></lm-mouse-over-text></div>
            </div>
            <soho-listview #SohoListView_InaccessibleItems data-automation-id="lm-report-security-inaccessible-items-listview"
              selectable='true'
              disableItemDeactivation="'true'">
              @for (item of notAccessibleItemsKeys; track item; let i = $index) {
                <li soho-listview-item>
                  <div class="lm-flex-row-container-no-wrap">
                    <span attr.data-automation-id="inaccessible-item-{{item}}" class="font-size-sm lm-bold">{{item}}</span>
                    @if (notAccessibleItems[item].length > 1) {
                      <span class="font-size-sm" style="width:100%; margin-left: 8px;"> ({{notAccessibleItems[item]}})</span>
                    }
                    @if (!notAccessibleItems[item]) {
                      <span>
                        <svg attr.data-automation-id="lm-report-security-inaccessible-item-alert-{{item}}"class="icon icon-alert lm-alert"
                          soho-tooltip [content]="'InvalidInaccessibleReportItemAlert' | translate"><use xlink:href="#icon-alert"></use></svg>
                        </span>
                      }
                      <ng-template #elseTitle>{{notAccessibleItems[item]}}</ng-template>
                      <span class="lm-flex-row-container-no-wrap-right ">
                        <button soho-button="tertiary" icon="delete" (click)="onInaccessibleItemRemove(item)" attr.data-automation-id="lm-report-security-inaccessible-item-delete-btn-{{item}}">{{'Delete' | translate}}</button>
                      </span>
                    </div>
                  </li>
                }
              </soho-listview>
            </div>
          }
        </div>
      </div>


